module.exports = __webpack_public_path__ + "img/3PC.e709740a.png";